import React from "react";
import Index from "../Index";
import * as XLSX from "xlsx";

const ImportExcelSheet = (props) => {
  // const handleChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const csvData = e.target.result;
  //       const workbook = XLSX.read(csvData, { type: "binary" });
  //       const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  //       const json = XLSX.utils.sheet_to_json(worksheet);
  //       if (json?.length > 0) {
  //         props?.getExcelData(json, file);
  //       }
  //     };

  //     reader.readAsBinaryString(file);
  //   }
  // };

  const excelDateToJSDate = (serial) => {
    const date = new Date(Math.round((serial - 25569) * 86400 * 1000));
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const csvData = e.target.result;
        const workbook = XLSX.read(csvData, { type: "binary" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(worksheet);

        if (json?.length > 0) {
          // Fix date fields
          const formattedJson = json.map((row) => {
            const newRow = { ...row };
            if (typeof newRow.Date === "number") {
              newRow.Date = excelDateToJSDate(newRow.Date);
            }
            return newRow;
          });

          props?.getExcelData(formattedJson, file);
        }
      };

      reader.readAsBinaryString(file);
    }
  };

  return (
    <Index.Box className="btn-primary-main">
      <label
        className={props?.className || "btn-primary"}
        htmlFor={props?.id}
        style={{ cursor: "pointer" }}
      >
        {props?.btnLabel}
      </label>
      <input
        type="file"
        id={props?.id}
        value=""
        name="account-file"
        className="custom-form-control"
        onChange={handleChange}
        hidden
        accept={props?.accept}
      />
    </Index.Box>
  );
};

export default ImportExcelSheet;
